var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WDatePicker',{attrs:{"date":_vm.selectedOptionValue,"label":_vm.label,"range":"","clear-event":_vm.clearEvent,"outlined":_vm.outlined,"dense":_vm.dense},on:{"update:date":[function($event){_vm.selectedOptionValue=$event},_vm.setDate],"click:clear":_vm.onClear}})
}
var staticRenderFns = []

export { render, staticRenderFns }